import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function fetchLastchatHistory(companyId) {
    try {
        const response = await getAxiosInstance().get(`/findLatestChatHistoryByUserAndCompanyCode/${companyId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function Userchatsubmit(payload) {
    try {
        const response = await getAxiosInstance().post(`/searchCrmData`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function genieChatDelte(id) {
    try {
        const response = await getAxiosInstance().delete(`/deleteChatHistory/${id}`, { headers })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function genieChatClear(code) {
    try {
        const response = await getAxiosInstance().delete(`/clearAllChatHistory/${code}`, { headers })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    fetchLastchatHistory,
    Userchatsubmit,
    genieChatDelte,
    genieChatClear,
}